export const QUOTE_TYPE_OPEN = 'quote_open';
export const QUOTE_TYPE_CLOSED = 'quote_closed';
export const ORDER_TYPE_OPEN = 'order_open';
export const ORDER_TYPE_CLOSE = 'order_close';
export const ORDER_DEFAULT_CURRENCY = 'EUR';
export const NO_DATA_STRING = '-';
export const ORDER_VIEW_SIMPLE = 'view_simple';
export const ORDER_VIEW_ACCORDION = 'view_accordion';
